import React from 'react';

/**
 * Catches render/runtime errors anywhere below it and shows a readable message
 * instead of a blank white screen. With source maps enabled the stack points at
 * the real file:line.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('App crash:', error, info?.componentStack);
  }

  render() {
    const { error, info } = this.state;
    if (!error) return this.props.children;
    return (
      <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', maxWidth: 800, margin: '0 auto' }}>
        <h2 style={{ marginBottom: 8 }}>Something went wrong</h2>
        <p style={{ color: '#64748b', marginTop: 0 }}>The page hit an error. You can reload — your data is safe.</p>
        <pre style={{ whiteSpace: 'pre-wrap', color: '#b91c1c', background: '#fef2f2', padding: 12, borderRadius: 8 }}>
          {String(error?.message || error)}
        </pre>
        <details style={{ marginTop: 8 }}>
          <summary style={{ cursor: 'pointer' }}>Technical details</summary>
          <pre style={{ whiteSpace: 'pre-wrap', fontSize: 12, color: '#475569', overflow: 'auto' }}>
            {error?.stack}{'\n'}{info?.componentStack}
          </pre>
        </details>
        <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
          <button onClick={() => { this.setState({ error: null, info: null }); }} style={btn}>Try again</button>
          <button onClick={() => window.location.reload()} style={btn}>Reload</button>
        </div>
      </div>
    );
  }
}

const btn = { padding: '8px 14px', borderRadius: 8, border: '1px solid #cbd5e1', background: '#fff', cursor: 'pointer' };
